import { UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './KokonTooltipContent.css';
import { stopPropagation } from '../../../../../utils/stopPropagation';

export const KokonTooltipContent: React.FC = (): React.JSX.Element => {
  return (
    <div className={styles['container']} onClick={stopPropagation}>
      <h4 className={styles['title']}>
        <UIHeading4>Агентство входит в ассоциацию КОКОН</UIHeading4>
      </h4>
      <a
        className={styles['link']}
        href="https://hc.cian.ru/hc/ru/articles/5184413035924"
        target="_blank"
        rel="noopener noreferrer"
      >
        <UIText2 color="primary_100">Подробнее</UIText2>
      </a>
      <UIText2>
        Компания является участником профессиональной ассоциации консультантов коммерческой недвижимости и&nbsp;работает
        в&nbsp;соответствии с&nbsp;утверждёнными стандартами качества услуг
      </UIText2>
    </div>
  );
};
